<template>
  <div class="container border-b border-gray-lightest py-4">
    <div class="flex items-center justify-between">
      <div class="mr-3 flex items-center">
        <button
          v-if="!isTopLevel"
          type="button"
          class="relative flex items-center justify-center text-black focus:outline-none"
          @click="localOpen = false"
        >
          <span class="sr-only" v-text="$t('mega_menu.close_button.label')" />
          <FontAwesomeIcon
            :icon="{ prefix: 'fas', iconName: 'chevron-left' }"
            aria-hidden="true"
            class="size-5"
          />
        </button>
      </div>

      <DialogTitle
        v-if="title"
        :title="title"
        class="truncate text-nowrap text-center font-bold"
      >
        {{ title }}
      </DialogTitle>
      <div class="ml-3 flex items-center">
        <button
          type="button"
          class="relative flex items-center justify-center text-black focus:outline-none"
          @click="megaMenuStore.closeMegaMenu()"
        >
          <span class="sr-only" v-text="$t('mega_menu.close_button.label')" />
          <FontAwesomeIcon
            :icon="{ prefix: 'fas', iconName: 'times' }"
            aria-hidden="true"
            class="size-6"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { DialogTitle } from '@headlessui/vue';
import { computed } from 'vue';
import { useMegaMenuStore } from '@/stores/MegaMenu/MegaMenuStore.ts';

const emits = defineEmits(['update:open']);

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
    default: false,
  },

  title: {
    type: String,
    required: false,
    default: undefined,
  },

  isTopLevel: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const megaMenuStore = useMegaMenuStore();

const localOpen = computed({
  get: () => props.open,
  set: value => {
    emits('update:open', value);
  },
});
</script>
